import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.9574 20.5387L10.9362 13.1137C10.3546 12.4986 10.3546 11.5014 10.9362 10.8863L17.9574 3.46133C18.5391 2.84622 19.4821 2.84622 20.0638 3.46133C20.6454 4.07643 20.6454 5.0737 20.0638 5.68881L14.0958 12L20.0638 18.3112C20.6454 18.9263 20.6454 19.9236 20.0638 20.5387C19.4821 21.1538 18.5391 21.1538 17.9574 20.5387ZM10.9574 20.5387L3.93624 13.1137C3.35459 12.4986 3.35459 11.5014 3.93624 10.8863L10.9574 3.46133C11.5391 2.84622 12.4821 2.84622 13.0638 3.46133C13.6454 4.07643 13.6454 5.0737 13.0638 5.68881L7.09577 12L13.0638 18.3112C13.6454 18.9263 13.6454 19.9236 13.0638 20.5387C12.4821 21.1538 11.5391 21.1538 10.9574 20.5387Z"
      fill={fill}
    />
    <mask
      id="mask0_240_2351"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="3"
      y="3"
      width="18"
      height="18"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.9574 20.5387L10.9362 13.1137C10.3546 12.4986 10.3546 11.5014 10.9362 10.8863L17.9574 3.46133C18.5391 2.84622 19.4821 2.84622 20.0638 3.46133C20.6454 4.07643 20.6454 5.0737 20.0638 5.68881L14.0958 12L20.0638 18.3112C20.6454 18.9263 20.6454 19.9236 20.0638 20.5387C19.4821 21.1538 18.5391 21.1538 17.9574 20.5387ZM10.9574 20.5387L3.93624 13.1137C3.35459 12.4986 3.35459 11.5014 3.93624 10.8863L10.9574 3.46133C11.5391 2.84622 12.4821 2.84622 13.0638 3.46133C13.6454 4.07643 13.6454 5.0737 13.0638 5.68881L7.09577 12L13.0638 18.3112C13.6454 18.9263 13.6454 19.9236 13.0638 20.5387C12.4821 21.1538 11.5391 21.1538 10.9574 20.5387Z"
        fill="transparent"
      />
    </mask>
    <g mask="url(#mask0_240_2351)">
      <rect
        width="80"
        height="80"
        transform="matrix(-1 0 0 1 52 -30)"
        fill={fill}
      />
    </g>
  </>
);

export default Icon;
